import StandardTooltip from './StandardTooltip';
export * from './StandardTooltip';
export default StandardTooltip;